<template>
<div>
    <HeaderMember header="เพิ่มลูกค้าส่งเงินสด" :img_header="header_image" link_back="customer" />
    <AddCustomerList />
</div>
</template>

<script>
import HeaderImage from '@/assets/add-user.png'
import HeaderMember from '@/components/admin/member/headermember/HeaderMember.vue'
import AddCustomerList from '@/components/admin/member/customer/AddCustomerList.vue'

export default {
    name: 'addCustomer',
    components: {
        HeaderMember,
        AddCustomerList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
